/**
 * LinkedIn Events Data Configuration
 * 
 * Manage upcoming webinars, roundtable discussions, and past briefings here.
 * Set date in YYYY-MM-DD format. The system automatically detects whether
 * an event is upcoming or concluded based on the current date.
 */

export const LINKEDIN_EVENTS = [
  {
    id: "ila-2026-healthcare-leadership-garwe",
    badge: "Featured Conference Session",
    title: "Healthcare Leadership for 2027 and Beyond: What's Needed, What's Best, and What's Ethical",
    description: "Featured panel at the 28th ILA Global Conference examining AI, ethics, inclusion, and healthcare innovation, featuring Francis Garwe alongside Canadian healthcare executives.",
    date: "2026-10-29",
    displayDate: "Thursday, October 29, 2026",
    time: "2:45 PM to 3:45 PM EST",
    host: "28th ILA Global Conference • Toronto",
    tagline: "Featuring Francis Garwe • Open Registration",
    registrationUrl: "https://www.linkedin.com/posts/international-leadership-association_healthcareleadership-leadership-healthcareinnovation-activity-7498115776785104896-zJZu?utm_medium=ios_app&rcm=ACoAAABlgoQBO74t7J6bUBCwWMBQQc3rrJEAsU0&utm_source=social_share_send&utm_campaign=whatsapp",
    recapUrl: "https://www.linkedin.com/posts/international-leadership-association_healthcareleadership-leadership-healthcareinnovation-activity-7498115776785104896-zJZu?utm_medium=ios_app&rcm=ACoAAABlgoQBO74t7J6bUBCwWMBQQc3rrJEAsU0&utm_source=social_share_send&utm_campaign=whatsapp",
    isRegistrationOpen: true,
    ctaText: "Register on LinkedIn"
  },
  {
    id: "webinar-physician-executive-disputes",
    badge: "Upcoming Executive Webinar",
    title: "Resolving High Stakes Physician Executive Disputes & Protecting Retention",
    description: "An evidence based executive briefing on statutory confidentiality, neutral mediation frameworks, and clinical ROI for health systems.",
    date: "2026-11-19",
    displayDate: "Thursday, November 19, 2026",
    time: "2:00 PM to 3:15 PM EST",
    host: "Hosted by NFBG Scorpio Advisory Group",
    tagline: "Complimentary for Health System Executives & Clinical Directors",
    registrationUrl: "https://www.linkedin.com/company/nfbg-scorpio/events/",
    recapUrl: "https://www.linkedin.com/company/nfbg-scorpio/",
    isRegistrationOpen: true,
    ctaText: "Register on LinkedIn"
  },
  {
    id: "webinar-clinical-adr-roi",
    badge: "Recent Executive Briefing",
    title: "Clinical Conflict Governance: Institutional ROI & Section 1157 Protections",
    description: "A specialized briefing exploring privileged dispute resolution under statutory peer review protections.",
    date: "2026-09-18",
    displayDate: "Wednesday, September 18, 2026",
    time: "1:00 PM to 2:15 PM EST",
    host: "Hosted by NFBG Scorpio Advisory Group",
    tagline: "Executive Summary & Recording Available",
    registrationUrl: "https://www.linkedin.com/company/nfbg-scorpio/events/",
    recapUrl: "https://www.linkedin.com/company/nfbg-scorpio/",
    isRegistrationOpen: false,
    ctaText: "View on LinkedIn"
  }
];

/**
 * Helper to determine the active event to showcase in the navigation card.
 * Prioritizes the soonest upcoming event; if all events are in the past,
 * returns the most recent concluded event.
 */
export const getFeaturedEvent = (events = LINKEDIN_EVENTS) => {
  if (!events || events.length === 0) return null;

  const todayStr = new Date().toISOString().split("T")[0];

  // 1. Check for upcoming events (date >= today)
  const upcomingEvents = events
    .filter((e) => e.date >= todayStr)
    .sort((a, b) => a.date.localeCompare(b.date));

  if (upcomingEvents.length > 0) {
    const nextEvent = upcomingEvents[0];
    return {
      ...nextEvent,
      isUpcoming: true,
      badgeText: nextEvent.badge || "Upcoming Executive Workshop",
      ctaText: nextEvent.ctaText || (nextEvent.isRegistrationOpen ? "Register on LinkedIn" : "View on LinkedIn"),
      targetUrl: nextEvent.registrationUrl || nextEvent.recapUrl || "https://www.linkedin.com"
    };
  }

  // 2. Fall back to the most recently concluded event
  const pastEvents = events
    .filter((e) => e.date < todayStr)
    .sort((a, b) => b.date.localeCompare(a.date));

  const recentEvent = pastEvents[0] || events[0];
  return {
    ...recentEvent,
    isUpcoming: false,
    badgeText: recentEvent.badge || "Recent Executive Briefing",
    ctaText: recentEvent.ctaText || "View Event on LinkedIn",
    targetUrl: recentEvent.recapUrl || recentEvent.registrationUrl || "https://www.linkedin.com"
  };
};
